// extracted by mini-css-extract-plugin
export default {"columnNarrow":"rates_table_header_columnNarrow__fmc0b","tableHeaderWrapper":"rates_table_header_tableHeaderWrapper__LQnJ9"};